export function logCursorParamsV1016(state, params, scope) {
  const { p = 0, ...filters } = params;
  if (scope === 'unknown') return params;
  const identity = JSON.stringify(filters);
  if (p === 0) {
    state.identity = identity;
    state.cursors = {};
    state.enabled = false;
    state.next = undefined;
    return { ...params, cursor_mode: '1' };
  }
  if (state.identity === identity && state.cursors[p]) {
    return { ...params, cursor_mode: '1', cursor: state.cursors[p] };
  }
  return params;
}

export function acceptLogCursorV1016(state, envelope, page) {
  state.enabled = envelope.cursor_mode === true;
  state.next = state.enabled ? envelope.next_cursor || '' : undefined;
  if (state.next) state.cursors[page + 1] = state.next;
}
